// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and base styles */
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    background: linear-gradient(135deg, #1a1a2e, #16213e);
    color: #e0e0e0;
    min-height: 100vh;
    padding: 20px;
    line-height: 1.6;
}

/* Container */
.container {
    max-width: 1200px;
    margin: 0 auto;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 20px;
    padding: 30px;
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

/* Headings */
h1 {
    text-align: center;
    margin-bottom: 30px;
    font-size: 2.5em;
    background: linear-gradient(45deg, #4facfe, #00f2fe);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

h3, h4 {
    margin-bottom: 15px;
    color: #4facfe;
    border-bottom: 1px solid rgba(79, 172, 254, 0.3);
    padding-bottom: 5px;
}

/* Buttons */
.button-group {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-bottom: 25px;
    flex-wrap: wrap;
}

button {
    padding: 12px 24px;
    border: none;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.start-button {
    background: linear-gradient(145deg, #3498db, #2980b9);
}

.start-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.test-button {
    background: linear-gradient(145deg, #9b59b6, #8e44ad);
}

.test-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.preset-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: 20px 0;
    flex-wrap: wrap;
}

.preset-btn {
    background: linear-gradient(145deg, #2ecc71, #27ae60);
    min-width: 100px;
}

.play-btn {
    background: linear-gradient(145deg, #f39c12, #e67e22);
    min-width: 100px;
}

.play-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.preset-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Control Panels */
.control-panel {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.control-section {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    padding: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Sliders */
.slider-group {
    margin-bottom: 15px;
}

.slider-label {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    font-size: 14px;
    color: #bdc3c7;
}

input[type="range"] {
    width: 100%;
    height: 6px;
    -webkit-appearance: none;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    outline: none;
    margin: 10px 0;
}

input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    background: #4facfe;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;
}

input[type="range"]:hover::-webkit-slider-thumb {
    transform: scale(1.2);
    background: #00f2fe;
}

/* Status and Debug */
.status {
    text-align: center;
    margin: 20px 0;
    padding: 10px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.2);
    font-weight: 500;
}

.debug-log {
    margin-top: 30px;
    padding: 15px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    max-height: 200px;
    overflow-y: auto;
    font-family: monospace;
    font-size: 14px;
    line-height: 1.4;
    color: #bdc3c7;
}

/* Oscilloscope */
.oscilloscope {
    width: 100%;
    height: 150px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    margin: 20px 0;
    display: block;
}

/* Responsive Design */
@media (max-width: 768px) {
    .control-panel {
        grid-template-columns: 1fr;
    }
    
    .button-group {
        flex-direction: column;
        align-items: center;
    }
    
    button, .preset-btn {
        width: 100%;
        max-width: 300px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/index.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,8EAA8E;IAC9E,qDAAqD;IACrD,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,iBAAiB;IACjB,cAAc;IACd,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oDAAoD;IACpD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,wCAAwC;IACxC,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qDAAqD;IACrD,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;IACrD,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,wCAAwC;AAC5C;;AAEA,YAAY;AACZ;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":["/* Reset and base styles */\n* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\nbody {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    background: linear-gradient(135deg, #1a1a2e, #16213e);\n    color: #e0e0e0;\n    min-height: 100vh;\n    padding: 20px;\n    line-height: 1.6;\n}\n\n/* Container */\n.container {\n    max-width: 1200px;\n    margin: 0 auto;\n    background: rgba(0, 0, 0, 0.4);\n    border-radius: 20px;\n    padding: 30px;\n    backdrop-filter: blur(10px);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n\n/* Headings */\nh1 {\n    text-align: center;\n    margin-bottom: 30px;\n    font-size: 2.5em;\n    background: linear-gradient(45deg, #4facfe, #00f2fe);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\nh3, h4 {\n    margin-bottom: 15px;\n    color: #4facfe;\n    border-bottom: 1px solid rgba(79, 172, 254, 0.3);\n    padding-bottom: 5px;\n}\n\n/* Buttons */\n.button-group {\n    display: flex;\n    justify-content: center;\n    gap: 15px;\n    margin-bottom: 25px;\n    flex-wrap: wrap;\n}\n\nbutton {\n    padding: 12px 24px;\n    border: none;\n    border-radius: 12px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    color: white;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\nbutton:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.start-button {\n    background: linear-gradient(145deg, #3498db, #2980b9);\n}\n\n.start-button:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.test-button {\n    background: linear-gradient(145deg, #9b59b6, #8e44ad);\n}\n\n.test-button:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.preset-buttons {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin: 20px 0;\n    flex-wrap: wrap;\n}\n\n.preset-btn {\n    background: linear-gradient(145deg, #2ecc71, #27ae60);\n    min-width: 100px;\n}\n\n.play-btn {\n    background: linear-gradient(145deg, #f39c12, #e67e22);\n    min-width: 100px;\n}\n\n.play-btn:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.preset-btn:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Control Panels */\n.control-panel {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 20px;\n    margin-bottom: 30px;\n}\n\n.control-section {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 12px;\n    padding: 15px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Sliders */\n.slider-group {\n    margin-bottom: 15px;\n}\n\n.slider-label {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 5px;\n    font-size: 14px;\n    color: #bdc3c7;\n}\n\ninput[type=\"range\"] {\n    width: 100%;\n    height: 6px;\n    -webkit-appearance: none;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 3px;\n    outline: none;\n    margin: 10px 0;\n}\n\ninput[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 16px;\n    height: 16px;\n    background: #4facfe;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\ninput[type=\"range\"]:hover::-webkit-slider-thumb {\n    transform: scale(1.2);\n    background: #00f2fe;\n}\n\n/* Status and Debug */\n.status {\n    text-align: center;\n    margin: 20px 0;\n    padding: 10px;\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.2);\n    font-weight: 500;\n}\n\n.debug-log {\n    margin-top: 30px;\n    padding: 15px;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 8px;\n    max-height: 200px;\n    overflow-y: auto;\n    font-family: monospace;\n    font-size: 14px;\n    line-height: 1.4;\n    color: #bdc3c7;\n}\n\n/* Oscilloscope */\n.oscilloscope {\n    width: 100%;\n    height: 150px;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 8px;\n    margin: 20px 0;\n    display: block;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .control-panel {\n        grid-template-columns: 1fr;\n    }\n    \n    .button-group {\n        flex-direction: column;\n        align-items: center;\n    }\n    \n    button, .preset-btn {\n        width: 100%;\n        max-width: 300px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
